export const FETCH_SELECTED_MONTH_RANGE = 'FETCH_SELECTED_MONTH_RANGE'
export const FETCH_COST_PIVOT_REQUEST = 'FETCH_COST_PIVOT_REQUEST'
export const FETCH_COST_PIVOT_SUCCESS = 'FETCH_COST_PIVOT_SUCCESS'
export const FETCH_COST_PIVOT_FAILED = 'FETCH_COST_PIVOT_FAILED'
export const CREATE_COST_PIVOT_FILTER_REQUEST = 'CREATE_COST_PIVOT_FILTER_REQUEST'
export const CREATE_COST_PIVOT_FILTER_SUCCESS = 'CREATE_COST_PIVOT_FILTER_SUCCESS'
export const CREATE_COST_PIVOT_FILTER_FAILED = 'CREATE_COST_PIVOT_FILTER_FAILED'
export const FETCH_COST_PIVOT_FILTER_REQUEST = 'FETCH_COST_PIVOT_FILTER_REQUEST'
export const FETCH_COST_PIVOT_FILTER_SUCCESS = 'FETCH_COST_PIVOT_FILTER_SUCCESS'
export const FETCH_COST_PIVOT_FILTER_FAILED = 'FETCH_COST_PIVOT_FILTER_FAILED'
export const FETCH_COST_PIVOT_FILTER_CONTENT = 'FETCH_COST_PIVOT_FILTER_CONTENT'
export const DELETE_COST_PIVOT_FILTER_REQUEST = 'DELETE_COST_PIVOT_FILTER_REQUEST'
export const DELETE_COST_PIVOT_FILTER_SUCCESS = 'DELETE_COST_PIVOT_FILTER_SUCCESS'
export const DELETE_COST_PIVOT_FILTER_FAILED = 'DELETE_COST_PIVOT_FILTER_FAILED'
export const FETCH_COST_PIVOT_FILTER_NAMES_REQUEST = 'FETCH_COST_PIVOT_FILTER_NAMES_REQUEST'
export const FETCH_COST_PIVOT_FILTER_NAMES_SUCCESS = 'FETCH_COST_PIVOT_FILTER_NAMES_SUCCESS'
export const FETCH_COST_PIVOT_FILTER_NAMES_FAILED = 'FETCH_COST_PIVOT_FILTER_NAMES_FAILED'
export const FETCH_USER_TAGS_REQUEST = 'FETCH_USER_TAGS_REQUEST'
export const FETCH_USER_TAGS_SUCCESS = 'FETCH_USER_TAGS_SUCCESS'
export const FETCH_USER_TAGS_FAILED = 'FETCH_USER_TAGS_FAILED'
export const FETCH_COST_PIVOT_DOWNLOAD_REQUEST = 'FETCH_COST_PIVOT_DOWNLOAD_REQUEST'
export const FETCH_COST_PIVOT_DOWNLOAD_SUCCESS = 'FETCH_COST_PIVOT_DOWNLOAD_SUCCESS'
export const FETCH_COST_PIVOT_DOWNLOAD_FAILED = 'FETCH_COST_PIVOT_DOWNLOAD_FAILED'
export const FETCH_COST_PIVOT_DOWNLOAD_STATUS_REQUEST = 'FETCH_COST_PIVOT_DOWNLOAD_STATUS_REQUEST'
export const FETCH_COST_PIVOT_DOWNLOAD_STATUS_SUCCESS = 'FETCH_COST_PIVOT_DOWNLOAD_STATUS_SUCCESS'
export const FETCH_COST_PIVOT_DOWNLOAD_STATUS_FAILED = 'FETCH_COST_PIVOT_DOWNLOAD_STATUS_FAILED'
export const RESET_DOWNLOAD_LINK = 'RESET_DOWNLOAD_LINK'
export const RESET_DOWNLOAD_STATUS = 'RESET_DOWNLOAD_STATUS'
export const SET_DOWNLOAD_MODE = 'SET_DOWNLOAD_MODE'
export const FETCH_COST_DOWNLOAD_REQUEST = 'FETCH_COST_DOWNLOAD_REQUEST'
export const FETCH_COST_DOWNLOAD_SUCCESS = 'FETCH_COST_DOWNLOAD_SUCCESS'
export const FETCH_COST_DOWNLOAD_FAILED = 'FETCH_COST_DOWNLOAD_FAILED'
export const FETCH_COST_DOWNLOAD_STATUS_REQUEST = 'FETCH_COST_DOWNLOAD_STATUS_REQUEST'
export const FETCH_COST_DOWNLOAD_STATUS_SUCCESS = 'FETCH_COST_DOWNLOAD_STATUS_SUCCESS'
export const FETCH_COST_DOWNLOAD_STATUS_FAILED = 'FETCH_COST_DOWNLOAD_STATUS_FAILED'
export const RESET_COST_DOWNLOAD_LINK = 'RESET_COST_DOWNLOAD_LINK'
export const RESET_COST_DOWNLOAD_STATUS = 'RESET_COST_DOWNLOAD_STATUS'
export const UPDATE_COST_PIVOT_SUMMARY = 'UPDATE_COST_PIVOT_SUMMARY'
